import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem, FilterChange } from 'app/shared/models/filter-group.models';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-date-filter',
    templateUrl: './date-filter.component.html',
    styleUrls: ['./date-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateFilterComponent implements OnChanges {

  @Input() filter: InternalFilterGroup;
  @Input() dataToView: FilterItem[] = [];

  @Output() change = new EventEmitter<FilterChange>();

  filterOptions = new BehaviorSubject<FilterItem[]>([]);

  utilsFunction = UtilityFunctions;

  constructor(
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataToView) {
      this.filterOptions.next(this.dataToView);
    }
  }

  onChange(data: string, item: FilterItem) {
    item.value = data;
    this.filter.data = this.filterOptions.value;
  }

}
